import { useTranslation } from "react-i18next";

import type { EmblaCarouselType } from "../emblaCarouselTypes";

import { DotButton } from "./DotButton";
import { useDotNavigation } from "./useDotNavigation";

import * as styles from "./DotNavigation.styles";

interface Props {
  emblaApi: EmblaCarouselType;
}

const DotNavigation = ({ emblaApi }: Props) => {
  const { t } = useTranslation();

  const { selectedIndex, scrollSnaps, onDotButtonClick, renderAriaLabel } =
    useDotNavigation(emblaApi);

  const renderDots = scrollSnaps.map((_, index) => {
    return (
      <li key={index}>
        <DotNavigation.Button
          aria-label={t(renderAriaLabel(index))}
          isSelected={index === selectedIndex}
          onClick={() => onDotButtonClick(index)}
        />
      </li>
    );
  });

  return (
    <ul css={styles.wrapper} data-testid="dot-navigation">
      {renderDots}
    </ul>
  );
};

DotNavigation.displayName = "NewCarousel.DotNavigation";
DotNavigation.Button = DotButton;

export { DotNavigation };
